module.exports = __webpack_public_path__ + "static/img/16.b2b78f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/sp/16.png
// module id = iKFz
// module chunks = 0